<template>
  <td>
    <div>
      <a :href="linkObject" target="_blank" rel="noopener noreferrer">öffnen</a>
    </div>
  </td>
</template>
<script>
export default { 
    name: "DocumentLinkContainer",   
    props: {
        dataItem: Object
    },
    computed: {
        linkObject: function () {          
          return  this.dataItem["documentUrl"]
        }
    }
}
</script>
